import { render, staticRenderFns } from "./VlModalAddFiles.vue?vue&type=template&id=627b0632&scoped=true&"
import script from "./VlModalAddFiles.vue?vue&type=script&lang=js&"
export * from "./VlModalAddFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b0632",
  null
  
)

export default component.exports